import { __assign } from 'tslib';
import React, { isValidElement } from 'react';
import cn from 'classnames';
import { BaseCheckmark } from '../base-checkmark/Component.js';
import '../../../../checkbox/esm';
import '@alfalab/icons-glyph/CheckmarkMIcon';

var styles = {"option":"select__option_1d4ao","disabled":"select__disabled_1d4ao","checkmarkBefore":"select__checkmarkBefore_1d4ao","mobile":"select__mobile_1d4ao","checkmarkAfter":"select__checkmarkAfter_1d4ao","textContent":"select__textContent_1d4ao","selected":"select__selected_1d4ao","highlighted":"select__highlighted_1d4ao","content":"select__content_1d4ao"};
require('./index.css');

var BaseOption = function (_a) {
    var _b;
    var className = _a.className, option = _a.option, children = _a.children, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, multiple = _a.multiple, _c = _a.Checkmark, Checkmark = _c === void 0 ? BaseCheckmark : _c, _d = _a.checkmarkPosition, checkmarkPosition = _d === void 0 ? multiple ? 'before' : 'after' : _d, innerProps = _a.innerProps, dataTestId = _a.dataTestId, _e = _a.mobile, mobile = _e === void 0 ? false : _e;
    var content = children || option.content || option.key;
    var _f = option.showCheckMark, showCheckMark = _f === void 0 ? true : _f;
    var isTextContent = !isValidElement(content);
    var renderCheckmark = function () {
        if (Checkmark && showCheckMark) {
            return React.createElement(Checkmark, { disabled: disabled, selected: selected, multiple: multiple });
        }
        return null;
    };
    return (React.createElement("div", __assign({}, innerProps, { className: cn(styles.option, className, (_b = {},
            _b[styles.highlighted] = !mobile && highlighted,
            _b[styles.selected] = selected,
            _b[styles.disabled] = disabled,
            _b[styles.textContent] = isTextContent,
            _b[styles.mobile] = mobile,
            _b[styles.checkmarkAfter] = !isTextContent && checkmarkPosition === 'after',
            _b[styles.checkmarkBefore] = !isTextContent && checkmarkPosition === 'before',
            _b)), "data-test-id": dataTestId }),
        checkmarkPosition === 'before' && renderCheckmark(),
        React.createElement("div", { className: cn(styles.content) }, content),
        checkmarkPosition === 'after' && renderCheckmark()));
};

export { BaseOption };
